import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "pt-2" }
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = { class: "text-left" }
const _hoisted_6 = {
  key: 0,
  class: "text-left"
}
const _hoisted_7 = {
  key: 1,
  class: "text-left"
}
const _hoisted_8 = {
  key: 2,
  class: "text-left"
}
const _hoisted_9 = {
  key: 3,
  class: "text-left"
}
const _hoisted_10 = { class: "text-left" }
const _hoisted_11 = { style: {"position":"relative","width":"100%","height":"0","padding":"0","padding-bottom":"141.4516129032258%","margin-bottom":"50px"} }
const _hoisted_12 = ["viewBox"]
const _hoisted_13 = ["xlink:href", "height", "width"]
const _hoisted_14 = ["points", "onClick"]
const _hoisted_15 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_16 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { key: 3 }
const _hoisted_19 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentMenu = _resolveComponent("DocumentMenu")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_accounting_item_static = _resolveComponent("accounting-item-static")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!
  const _component_ossPdf = _resolveComponent("ossPdf")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn_edit = _resolveComponent("v-btn-edit")!
  const _component_v_btn_add = _resolveComponent("v-btn-add")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_AccountableAccount = _resolveComponent("AccountableAccount")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_UploadDocument = _resolveComponent("UploadDocument")!
  const _component_CompaniesTable = _resolveComponent("CompaniesTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6",
          class: "pl-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              style: {"height":"calc(100vh - 82px)","overflow-y":"auto"},
              class: "default_card_wm elevation-0 rounded-l-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DocumentMenu, {
                  MenuOptions: _ctx.documentMenuOptions,
                  displayMode: _ctx.windowStep,
                  "onUpdate:displayMode": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.windowStep) = $event)),
                  onBack: _cache[1] || (_cache[1] = ($event: any) => (_ctx.back())),
                  onZoomIn: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isPDF ? _ctx.zoomInPdf() : _ctx.zoomManager.zoomIn())),
                  onResetZoom: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isPDF ? _ctx.resetZoomPdf() : _ctx.zoomManager.resetZoom())),
                  onZoomOut: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isPDF ? _ctx.zoomOutPdf() : _ctx.zoomManager.zoomOut())),
                  onRotateLeft: _cache[5] || (_cache[5] = ($event: any) => (
                            _ctx.documentPdfRotation = _ctx.rotate('left', _ctx.zoomManager, _ctx.documentPdfRotation)
                        )),
                  onRotateRight: _cache[6] || (_cache[6] = ($event: any) => (
                            _ctx.documentPdfRotation = _ctx.rotate('right', _ctx.zoomManager, _ctx.documentPdfRotation)
                        )),
                  onActivity: _cache[7] || (_cache[7] = ($event: any) => (_ctx.windowStep = 'display-activity')),
                  onDownload: _cache[8] || (_cache[8] = ($event: any) => (_ctx.startDownloadFile())),
                  onUpload: _cache[9] || (_cache[9] = ($event: any) => (_ctx.uploadDocumentDialog = true)),
                  onDelete: _cache[10] || (_cache[10] = ($event: any) => (_ctx.deleteDocumentDialog = true))
                }, null, 8, ["MenuOptions", "displayMode"]),
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_window, {
                          modelValue: _ctx.windowStep,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.windowStep) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_window_item, { value: 'table' }, {
                              default: _withCtx(() => [
                                (!_ctx.$vuetify.display.mobile)
                                  ? (_openBlock(), _createBlock(_component_v_data_table, {
                                      key: 0,
                                      headers: _ctx.headers,
                                      items: _ctx.calculatedLeasing,
                                      class: "table",
                                      "fixed-header": "",
                                      "hide-default-footer": "",
                                      height: "90vh",
                                      "items-per-page": -1,
                                      density: "compact"
                                    }, {
                                      item: _withCtx((props) => [
                                        _createElementVNode("tr", {
                                          class: _normalizeClass(props.item.selected ? 'info' : '')
                                        }, [
                                          _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.formatDate(props.item.date)), 1),
                                          _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.netAmount,
                                                            undefined,
                                                        )), 1),
                                          _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.vatAmount,
                                                            undefined,
                                                        )), 1),
                                          _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.grossAmount,
                                                            undefined,
                                                        )), 1),
                                          (_ctx.hasInsuranceAmount)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_6, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.insuranceNetAmount,
                                                            undefined,
                                                        )), 1))
                                            : _createCommentVNode("", true),
                                          (_ctx.hasInsuranceAmount)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_7, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.insuranceVatAmount,
                                                            undefined,
                                                        )), 1))
                                            : _createCommentVNode("", true),
                                          (_ctx.hasMaintenanceAmount)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_8, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.maintenanceNetAmount,
                                                            undefined,
                                                        )), 1))
                                            : _createCommentVNode("", true),
                                          (_ctx.hasMaintenanceAmount)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_9, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.maintenanceVatAmount,
                                                            undefined,
                                                        )), 1))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.totalAmount,
                                                            undefined,
                                                        )), 1)
                                        ], 2)
                                      ]),
                                      _: 1
                                    }, 8, ["headers", "items"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_window_item, { value: 'display-accounting-lines' }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(), _createBlock(_component_accounting_item_static, {
                                          companyId: _ctx.selectedCompany.id,
                                          documentId: _ctx.document.id,
                                          mode: _ctx.isAccountingItem ? 'AllOption' : 'Embedded',
                                          ref: "accountingItemStatic",
                                          key: _ctx.accountingLinesRefreshKey,
                                          onUpdate: _ctx.startToBeDoneIfNecessary,
                                          onUpsert: _ctx.onAccountingItemUpdated
                                        }, null, 8, ["companyId", "documentId", "mode", "onUpdate", "onUpsert"]))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_window_item, { value: 'display-activity' }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_UsersActivitiesHistory, {
                                          documentId: _ctx.document.id
                                        }, null, 8, ["documentId"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_window_item, { value: 'display-pdf' }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    (_ctx.isPDF)
                                      ? (_openBlock(), _createBlock(_component_v_col, {
                                          key: 0,
                                          cols: "12",
                                          style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ossPdf, {
                                              ref: "ossPdfRef",
                                              documentId: _ctx.document.id
                                            }, null, 8, ["documentId"])
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createBlock(_component_v_col, {
                                          key: 1,
                                          cols: "12",
                                          style: {"height":"calc(100vh - 130px)","overflow-y":"auto"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_11, [
                                              (_ctx.document)
                                                ? (_openBlock(), _createElementBlock("svg", {
                                                    key: 0,
                                                    id: "svg-document-static",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "100%",
                                                    viewBox: `0 0 ${_ctx.imageWidth} ${_ctx.imageHeight}`,
                                                    style: {"position":"absolute","width":"100%","left":"0","top":"0","background":"#fff"}
                                                  }, [
                                                    _createElementVNode("g", null, [
                                                      _createElementVNode("image", {
                                                        id: "svg-image-document-static",
                                                        "xlink:href": _ctx.document.signedUrl,
                                                        x: "0",
                                                        y: "0",
                                                        height: `${_ctx.imageHeight}px`,
                                                        width: `${_ctx.imageWidth}px`
                                                      }, null, 8, _hoisted_13),
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.svgVariants, (variant, index) => {
                                                        return (_openBlock(), _createElementBlock(_Fragment, {
                                                          key: `coord-${_ctx.document.id}-${index}`
                                                        }, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variant.coordinates, (coord, index2) => {
                                                            return (_openBlock(), _createElementBlock("polygon", {
                                                              key: `coord-${_ctx.document.id}-${index}-${index2}`,
                                                              ref_for: true,
                                                              ref: `variants-${index}-${index2}`,
                                                              points: _ctx.getPoints(coord),
                                                              style: _normalizeStyle(
                                                                        variant.active
                                                                            ? 'fill:rgba(250,250,250,0.5);stroke:#F9B12A;stroke-width:1'
                                                                            : 'fill:rgba(250,250,250,0.5);stroke:gray;stroke-width:1;cursor:pointer'
                                                                    ),
                                                              onClick: _withModifiers(($event: any) => (
                                                                        variant.active
                                                                            ? ''
                                                                            : _ctx.showCorrespondingField(
                                                                                  {
                                                                                      variant,
                                                                                      currentIndex:
                                                                                          index,
                                                                                      copyIndex:
                                                                                          index2,
                                                                                  },
                                                                              )
                                                                    ), ["stop"]),
                                                              class: _normalizeClass(
                                                                        variant.focus
                                                                            ? 'highlighted'
                                                                            : ''
                                                                    )
                                                            }, null, 14, _hoisted_14))
                                                          }), 128))
                                                        ], 64))
                                                      }), 128))
                                                    ])
                                                  ], 8, _hoisted_12))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          _: 1
                                        }))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6",
          class: "my-0 pl-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              style: {"border-top-right-radius":"0px !important","border-bottom-right-radius":"0px !important","height":"calc(100vh - 82px)","overflow-y":"auto"},
              class: "default_card_wm elevation-0 rounded-l-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "pt-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "9" }),
                        _createVNode(_component_v_col, {
                          cols: "3",
                          class: "mt-2 d-flex align-right justify-end"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.isInsideAccountingClosing)
                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                  key: 0,
                                  bottom: ""
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                                      (_ctx.document.id)
                                        ? (_openBlock(), _createBlock(_component_v_btn_edit, {
                                            key: 0,
                                            disabled: true,
                                            onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.valid()), ["stop"]))
                                          }))
                                        : (_openBlock(), _createBlock(_component_v_btn_add, {
                                            key: 1,
                                            disabled: true,
                                            onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.valid()), ["stop"]))
                                          }))
                                    ], 16)
                                  ]),
                                  default: _withCtx(() => [
                                    _cache[56] || (_cache[56] = _createElementVNode("span", null, "Impossible d'ajouter ou modifier : la date sélectionnée se trouve dans une période comptable clôturée.", -1))
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (_ctx.document.id)
                                    ? (_openBlock(), _createBlock(_component_v_btn_edit, {
                                        key: 0,
                                        disabled: !_ctx.isValid,
                                        onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.valid()), ["stop"]))
                                      }, null, 8, ["disabled"]))
                                    : (_openBlock(), _createBlock(_component_v_btn_add, {
                                        key: 1,
                                        disabled: !_ctx.isValid,
                                        onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.valid()), ["stop"]))
                                      }, null, 8, ["disabled"]))
                                ], 64))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, {
                              class: "pt-0",
                              density: "compact"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item, {
                                  ripple: false,
                                  class: "oss-list-item mb-2",
                                  color: "success"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "d-flex align-center",
                                              style: {"border-right":"1px #ededed solid"}
                                            }, {
                                              default: _withCtx(() => _cache[57] || (_cache[57] = [
                                                _createElementVNode("b", null, "Nom", -1)
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "6",
                                              class: "d-flex align-center pl-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", null, _toDisplayString(_ctx.leasing.title), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item, {
                                  ripple: false,
                                  class: "oss-list-item mb-2",
                                  color: "success"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "d-flex align-center",
                                              style: {"border-right":"1px #ededed solid"}
                                            }, {
                                              default: _withCtx(() => _cache[58] || (_cache[58] = [
                                                _createElementVNode("b", null, "Statut", -1)
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "6",
                                              class: "d-flex align-center pl-2"
                                            }, {
                                              default: _withCtx(() => [
                                                (
                                                            _ctx.document.errorMessage &&
                                                            _ctx.reUploadDocument
                                                        )
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Erreur : " + _toDisplayString(_ctx.document.errorMessage), 1))
                                                  : (
                                                            _ctx.document && _ctx.document.errorMessage
                                                        )
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Erreur de lecture du fichier : contacter votre cabinet "))
                                                    : (
                                                            !_ctx.document.id &&
                                                            _ctx.leasing.status === 'ANALYSED'
                                                        )
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, " En cours de création "))
                                                      : (_ctx.document.status === 'VALIDATED')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Créé "))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_19, "OK"))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item, {
                                  ripple: false,
                                  class: "oss-list-item my-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, { class: "body-1" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, {
                                          "no-gutters": "",
                                          class: "align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              style: {"border-right":"1px #ededed solid","height":"28px"},
                                              class: "d-flex align-center"
                                            }, {
                                              default: _withCtx(() => _cache[59] || (_cache[59] = [
                                                _createElementVNode("b", null, "Type", -1)
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "9",
                                              class: "pl-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.formatCategory(_ctx.leasing.type)), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.activateTagguing)
                          ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_FreeTag, {
                                  companyTags: _ctx.allCompanyTags,
                                  document: _ctx.inDocument,
                                  splitUserPartitions: true,
                                  onChanged: _ctx.startToBeDoneIfNecessary,
                                  onOnTagsChanged: _ctx.upsertDocumentTags
                                }, null, 8, ["companyTags", "document", "onChanged", "onOnTagsChanged"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      class: "mt-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { class: "d-flex align-center col-auto pr-3 title" }, {
                          default: _withCtx(() => _cache[60] || (_cache[60] = [
                            _createTextVNode(" Informations leasing ")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_divider)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "mt-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_form, {
                              modelValue: _ctx.isValid,
                              "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.isValid) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { class: "mt-1" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "4" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field_filled, {
                                          modelValue: _ctx.leasing.title,
                                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.leasing.title) = $event)),
                                          label: "Libellé",
                                          outlined: "",
                                          "hide-details": "",
                                          rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                          density: "compact"
                                        }, null, 8, ["modelValue", "rules"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      class: "pl-1 mt-2 pt-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_switch, {
                                          modelValue: _ctx.leasing.firstPayRentOption,
                                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.leasing.firstPayRentOption) = $event)),
                                          label: "Montant 1er Loyer",
                                          "hide-details": ""
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      class: "pl-1 mt-2 pt-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_switch, {
                                          modelValue: _ctx.leasing.leasingPurchaseOption,
                                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.leasing.leasingPurchaseOption) = $event)),
                                          label: "Option d'achat",
                                          "hide-details": ""
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, { class: "mt-1" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "4" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field_filled, {
                                          modelValue: _ctx.leasing.invoiceNumber,
                                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.leasing.invoiceNumber) = $event)),
                                          label: "Numéro de contrat",
                                          outlined: "",
                                          density: "compact",
                                          "hide-details": "",
                                          rules: [(v) => !!v || _ctx.$t('settings.itemRequired')]
                                        }, null, 8, ["modelValue", "rules"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      class: "pl-1",
                                      cols: "4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_date_picker_filled, {
                                          modelValue: _ctx.leasing.startDate,
                                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.leasing.startDate) = $event)),
                                          label: `Date leasing`,
                                          textFieldReadOnly: false,
                                          rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                          "hide-details": ""
                                        }, null, 8, ["modelValue", "rules"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      class: "pl-1",
                                      cols: "4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field_filled, {
                                          label: "Nombre d'échéances",
                                          outlined: "",
                                          density: "compact",
                                          "hide-details": "",
                                          rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                          modelValue: _ctx.leasing.leasingPeriod,
                                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.leasing.leasingPeriod) = $event))
                                        }, null, 8, ["rules", "modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, { class: "mt-2" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "4" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field_filled, {
                                          modelValue: _ctx.leasing.netAmount,
                                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.leasing.netAmount) = $event)),
                                          modelModifiers: { number: true },
                                          label: "Loyer HT",
                                          outlined: "",
                                          density: "compact",
                                          "hide-details": "",
                                          rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                          onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.calculateAmount('netAmount')))
                                        }, null, 8, ["modelValue", "rules"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      class: "pl-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_select_filled, {
                                          modelValue: _ctx.leasing.vatRate,
                                          "onUpdate:modelValue": [
                                            _cache[24] || (_cache[24] = ($event: any) => ((_ctx.leasing.vatRate) = $event)),
                                            _cache[25] || (_cache[25] = ($event: any) => (_ctx.calculateAmount('vatRate')))
                                          ],
                                          modelModifiers: { number: true },
                                          label: "Taux TVA ( % )",
                                          items: _ctx.vatRates,
                                          "item-value": "vatRate",
                                          "return-object": "",
                                          outlined: "",
                                          "hide-details": "",
                                          rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                          density: "compact",
                                          "item-title": (item) => item.text
                                        }, null, 8, ["modelValue", "items", "rules", "item-title"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      class: "pl-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field_filled, {
                                          modelValue: _ctx.leasing.grossAmount,
                                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.leasing.grossAmount) = $event)),
                                          modelModifiers: { number: true },
                                          label: "Loyer TTC",
                                          outlined: "",
                                          density: "compact",
                                          "hide-details": "",
                                          rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                          onChange: _cache[27] || (_cache[27] = ($event: any) => (_ctx.calculateAmount('grossAmount')))
                                        }, null, 8, ["modelValue", "rules"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, { class: "mt-1" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "4" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field_filled, {
                                          label: "Assurances HT",
                                          outlined: "",
                                          density: "compact",
                                          "hide-details": "",
                                          onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.calculateAmount('insuranceNetAmount'))),
                                          modelValue: _ctx.leasing.insuranceNetAmount,
                                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.leasing.insuranceNetAmount) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      class: "pl-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_select_filled, {
                                          modelValue: _ctx.leasing.insuranceVatRate,
                                          "onUpdate:modelValue": [
                                            _cache[30] || (_cache[30] = ($event: any) => ((_ctx.leasing.insuranceVatRate) = $event)),
                                            _cache[31] || (_cache[31] = ($event: any) => (
                                                    _ctx.calculateAmount('insuranceVatRate')
                                                ))
                                          ],
                                          modelModifiers: { number: true },
                                          label: "TVA Assurances ( % )",
                                          items: _ctx.vatRates,
                                          "item-value": "vatRate",
                                          "return-object": "",
                                          outlined: "",
                                          "hide-details": "",
                                          density: "compact",
                                          "item-title": (item) => item.text
                                        }, null, 8, ["modelValue", "items", "item-title"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      class: "pl-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field_filled, {
                                          label: "Assurances TTC",
                                          outlined: "",
                                          density: "compact",
                                          "hide-details": "",
                                          onChange: _cache[32] || (_cache[32] = ($event: any) => (_ctx.calculateAmount('insuranceGrossAmount'))),
                                          modelValue: _ctx.leasing.insuranceGrossAmount,
                                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.leasing.insuranceGrossAmount) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, { class: "mt-1" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "4" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field_filled, {
                                          label: "Entretiens HT",
                                          outlined: "",
                                          density: "compact",
                                          "hide-details": "",
                                          onChange: _cache[34] || (_cache[34] = ($event: any) => (_ctx.calculateAmount('maintenanceNetAmount'))),
                                          modelValue: _ctx.leasing.maintenanceNetAmount,
                                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.leasing.maintenanceNetAmount) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      class: "pl-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_select_filled, {
                                          modelValue: _ctx.leasing.maintenanceVatRate,
                                          "onUpdate:modelValue": [
                                            _cache[36] || (_cache[36] = ($event: any) => ((_ctx.leasing.maintenanceVatRate) = $event)),
                                            _cache[37] || (_cache[37] = ($event: any) => (
                                                    _ctx.calculateAmount('maintenanceVatRate')
                                                ))
                                          ],
                                          modelModifiers: { number: true },
                                          label: "TVA Entretiens ( % )",
                                          items: _ctx.vatRates,
                                          "item-value": "vatRate",
                                          "return-object": "",
                                          outlined: "",
                                          "hide-details": "",
                                          density: "compact",
                                          "item-title": (item) => item.text
                                        }, null, 8, ["modelValue", "items", "item-title"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      class: "pl-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field_filled, {
                                          label: "Entretiens TTC",
                                          outlined: "",
                                          density: "compact",
                                          "hide-details": "",
                                          onChange: _cache[38] || (_cache[38] = ($event: any) => (_ctx.calculateAmount('maintenanceGrossAmount'))),
                                          modelValue: _ctx.leasing.maintenanceGrossAmount,
                                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.leasing.maintenanceGrossAmount) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, { class: "mt-2" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "4" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field_filled, {
                                          label: "Frais de dossier",
                                          outlined: "",
                                          density: "compact",
                                          "hide-details": "",
                                          modelValue: _ctx.leasing.applicationFeeAmount,
                                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.leasing.applicationFeeAmount) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      class: "pl-1"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.leasing.firstPayRentOption)
                                          ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                              key: 0,
                                              label: "Montant 1er loyer TTC",
                                              outlined: "",
                                              density: "compact",
                                              "hide-details": "",
                                              readonly: !_ctx.leasing.firstPayRentOption,
                                              disabled: !_ctx.leasing.firstPayRentOption,
                                              modelValue: _ctx.leasing.firstPayRentAmount,
                                              "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.leasing.firstPayRentAmount) = $event))
                                            }, null, 8, ["readonly", "disabled", "modelValue"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      class: "pl-1"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.leasing.leasingPurchaseOption)
                                          ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                              key: 0,
                                              label: "Montant résiduel",
                                              outlined: "",
                                              density: "compact",
                                              "hide-details": "",
                                              readonly: !_ctx.leasing.leasingPurchaseOption,
                                              disabled: !_ctx.leasing.leasingPurchaseOption,
                                              modelValue: _ctx.leasing.residualAmount,
                                              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.leasing.residualAmount) = $event))
                                            }, null, 8, ["readonly", "disabled", "modelValue"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, { class: "mt-2" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field_filled, {
                                          label: "Fournisseur",
                                          outlined: "",
                                          "hide-details": "",
                                          readonly: "",
                                          rules: [(v) => !!v || _ctx.$t('settings.itemRequired')],
                                          onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.thirdPartyCompanyDialog = true)),
                                          "model-value": _ctx.leasing.thirdPartyCompany.name,
                                          density: "compact"
                                        }, null, 8, ["rules", "model-value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_v_row, { class: "mt-2" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createVNode(_component_AccountableAccount, {
                                      showLabel: true,
                                      label: `Compte de mensualités`,
                                      inputStyle: 'padding:0px; margin:0px;',
                                      showValidation: false,
                                      companyId: _ctx.companyId,
                                      showDescription: true,
                                      inAccountableAccountType: 'Selected',
                                      inAccountableAccount: _ctx.accountableAccountMonthly,
                                      inAccountableAccountNames: ['612'],
                                      disabled: false,
                                      hideDetails: true,
                                      onSelectAccountableAccount: 
                                                _ctx.selectAccountableAccountMonthly
                                            ,
                                      defineThirdParty: false,
                                      dense: ""
                                    }, null, 8, ["companyId", "inAccountableAccount", "onSelectAccountableAccount"]), [
                                      [_vShow, true]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, { class: "mt-2" }, {
                              default: _withCtx(() => [
                                (_ctx.hasInsuranceAmount)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 0,
                                      cols: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createVNode(_component_AccountableAccount, {
                                          showLabel: true,
                                          label: `Compte d'assurances`,
                                          inputStyle: 'padding:0px; margin:0px;',
                                          showValidation: false,
                                          companyId: _ctx.companyId,
                                          showDescription: true,
                                          inAccountableAccountType: 'Selected',
                                          inAccountableAccount: _ctx.accountableAccountInsurance,
                                          inAccountableAccountNames: ['616'],
                                          disabled: false,
                                          hideDetails: true,
                                          onSelectAccountableAccount: 
                                                _ctx.selectAccountableAccountInsurance
                                            ,
                                          defineThirdParty: false,
                                          dense: ""
                                        }, null, 8, ["companyId", "inAccountableAccount", "onSelectAccountableAccount"]), [
                                          [_vShow, true]
                                        ])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.hasMaintenanceAmount)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 1,
                                      cols: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _withDirectives(_createVNode(_component_AccountableAccount, {
                                          showLabel: true,
                                          label: `Compte d'entretiens`,
                                          inputStyle: 'padding:0px; margin:0px;',
                                          showValidation: false,
                                          companyId: _ctx.companyId,
                                          showDescription: true,
                                          inAccountableAccountType: 'Selected',
                                          inAccountableAccountNames: ['615'],
                                          inAccountableAccount: _ctx.accountableAccountMaintenance,
                                          disabled: false,
                                          hideDetails: true,
                                          onSelectAccountableAccount: 
                                                _ctx.selectAccountableAccountMaintenance
                                            ,
                                          defineThirdParty: false,
                                          dense: ""
                                        }, null, 8, ["companyId", "inAccountableAccount", "onSelectAccountableAccount"]), [
                                          [_vShow, true]
                                        ])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.document.id)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          "no-gutters": "",
                          class: "mt-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "d-flex align-center col-auto pr-3 title" }, {
                              default: _withCtx(() => _cache[61] || (_cache[61] = [
                                _createTextVNode(" Informations arrêt anticipé ")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_divider)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "mt-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { class: "mt-1" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      class: "pl-2 mt-2 pt-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_switch, {
                                          modelValue: _ctx.leasing.leasingEarlyRedemption,
                                          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.leasing.leasingEarlyRedemption) = $event)),
                                          label: "Arrêt anticipé",
                                          "hide-details": ""
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "4",
                                      class: "pl-1"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.leasing.leasingEarlyRedemption)
                                          ? (_openBlock(), _createBlock(_component_v_select_filled, {
                                              key: 0,
                                              modelValue: _ctx.leasing.leasingEarlyRedemptionDate,
                                              "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.leasing.leasingEarlyRedemptionDate) = $event)),
                                              items: _ctx.leasingEarlyRedemptionDates,
                                              label: "Date d'arrêt anticipé",
                                              "item-value": "value",
                                              outlined: "",
                                              "hide-details": "",
                                              density: "compact",
                                              "item-title": (item) => item.text
                                            }, null, 8, ["modelValue", "items", "item-title"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_row, { class: "mt-1" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "d-flex justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn_prev, {
                              disabled: _ctx.previousDisabled(),
                              onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.previous()))
                            }, null, 8, ["disabled"]),
                            _createVNode(_component_v_btn_next, {
                              disabled: _ctx.nextDisabled(),
                              onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.next()))
                            }, null, 8, ["disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.deleteDocumentDialog,
      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.deleteDocumentDialog) = $event)),
      title: "Supprimer le document",
      error: true,
      onValid: _ctx.deleteDocument,
      validTitle: 'Oui je suis sûr(e)',
      validLoading: _ctx.deleteDocumentLoading,
      width: "800px"
    }, {
      default: _withCtx(() => _cache[62] || (_cache[62] = [
        _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir supprimer le document ?", -1)
      ])),
      _: 1
    }, 8, ["modelValue", "onValid", "validLoading"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.restoreDialog,
      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.restoreDialog) = $event)),
      title: "Restaurer le document",
      onValid: _cache[51] || (_cache[51] = ($event: any) => {
                _ctx.restoreDocument();
                _ctx.restoreDialog = false;
            }),
      validTitle: 'Oui je suis sûr(e)',
      validLoading: _ctx.restoreLoading,
      width: "800px"
    }, {
      default: _withCtx(() => _cache[63] || (_cache[63] = [
        _createElementVNode("h4", { class: "text-center" }, "Êtes-vous sûr(e) de vouloir restaurer le document ?", -1)
      ])),
      _: 1
    }, 8, ["modelValue", "validLoading"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.uploadDocumentDialog,
      "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.uploadDocumentDialog) = $event)),
      title: "Importer un document pour ce justificatif",
      "max-width": "60vw",
      actions: _ctx.actions
    }, {
      default: _withCtx(() => [
        _createVNode(_component_UploadDocument, {
          showFirstPrevious: false,
          companyId: _ctx.companyId,
          documentId: _ctx.document.id,
          documentType: 'MISCELLANEOUS',
          multiple: false,
          freeTag: false,
          showBtns: true,
          actions: _ctx.actions,
          onFileUploaded: _cache[52] || (_cache[52] = ($event: any) => {
                    _ctx.closeUploadDocumentDialog();
                    _ctx.startToBeDoneIfNecessary();
                })
        }, null, 8, ["companyId", "documentId", "actions"])
      ]),
      _: 1
    }, 8, ["modelValue", "actions"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.thirdPartyCompanyDialog,
      "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.thirdPartyCompanyDialog) = $event)),
      title: "Choisir un fournisseur",
      "max-width": "60vw"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CompaniesTable, {
          modelValue: _ctx.leasing.thirdPartyCompany,
          "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.leasing.thirdPartyCompany) = $event)),
          parentCompanyId: _ctx.companyId,
          showGenericCompany: false,
          showConsumerCompany: false,
          showCustomerCompanies: false,
          showSupplierCompanies: true,
          showExistingCompanies: true,
          showNewCompanies: true,
          onSelectCompany: _ctx.selectThirdPartyCompany
        }, null, 8, ["modelValue", "parentCompanyId", "onSelectCompany"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}